import {
  Button,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';

interface IMenuTipModalProps {
  isOpen: boolean;
  onClose: () => void;
  imagePath: string;
  textTip: string;
  textTitle: string;
}

function MenuTipModal(props: IMenuTipModalProps) {
  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} isCentered>
      <ModalOverlay />
      <ModalContent mx={'30px'}>
        <ModalHeader
          textAlign={'center'}
          fontSize="18px"
          fontWeight={'semibold'}
          mt="10px">
          {props.textTitle}
        </ModalHeader>
        <ModalBody px={'15px'}>
          <Image src={props.imagePath} />
          <Text
            whiteSpace={'pre-wrap'}
            fontSize={'13px'}
            mt="15px"
            lineHeight={'21px'}>
            {props.textTip}
          </Text>
        </ModalBody>
        <ModalFooter justifyContent={'center'} gap="10px" px={'15px'}>
          <Button
            colorScheme={'mint'}
            w={'full'}
            h="44px"
            fontSize={'15px'}
            fontWeight="bold"
            onClick={props.onClose}>
            확인
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
export default MenuTipModal;
